export const getStyleFromTextPreset = (wixParam, additionals = {}) => (Object.assign({ 
    // additional can be minHeight, textDecoration, color
    fontFamily: wixParam.fontFamily, fontSize: wixParam.size, lineHeight: wixParam.lineHeight, fontStyle: wixParam.style, fontWeight: wixParam.weight }, additionals));
//# sourceMappingURL=theme.js.map